let apiHost;

const hostname = window && window.location && window.location.hostname;

if (hostname === 'favacbid.airwis.com') {
  apiHost = 'https://favacbid-api.airwis.com/';
} else if (hostname === 'favacbidtest.airwis.com') {
  apiHost = 'https://favacbidtest-api.airwis.com/';
} else {
  apiHost = 'https://localhost:44303/';
}

export const API_ROOT = `${apiHost}`;